import React, {useState} from "react";
import {MessageSections} from "../../../../pages/components/message/message";
import {useAppSelector} from "../../../../redux/store";
import BarekamInput from "../../../../pages/components/input";
import {getMessage} from "../../../../pages/shared/helper-functions";

export const TrackNumberInput = ({onEnter}: TrackNumberInputProps) => {
    const {messageCache, languageId} = useAppSelector(state => state.messagesReducer);

    const [trackingNumber, setTrackingNumber] = useState('');

    function handleEnterKey() {
        onEnter(trackingNumber);
        setTrackingNumber('');
    }

    return (
        <BarekamInput value={trackingNumber}
                      key={'trackingNumber'}
                      placeholder={getMessage('tracking_number', MessageSections.ORDERS, messageCache, languageId)}
                      customInputVariant={"standard"}
                      width={'100%'}
                      onChange={(event) => setTrackingNumber(event.target.value)}
                      onKeyUp={(event) => event.key === 'Enter' && handleEnterKey()}
                      sx={{
                          width: '100%',
                          maxWidth: '40rem',
                          alignSelf: 'left',
                      }}
                      autoFocus/>
    );
}

interface TrackNumberInputProps {
    onEnter: (trackingNumber: string) => void,
}
